import React from 'react';

const UserCashDetailFormModal = React.lazy(() => import('../components/FormModal'));
const userCashDetailModalRegistry = {
    core_userCashDetailId: UserCashDetailFormModal
};
export default userCashDetailModalRegistry;
